
require('./plugins/fancy/jquery.fancybox.css');
require('./sass/style.scss');

//JS
require('./js/jquery');

require('./plugins/fancy/jquery.fancybox.js');

require('./plugins/owl/js/owl.carousel.js');
require('./plugins/owl/js/owl.navigation.js');
require('./plugins/owl/js/owl.autoplay.js');
require('./js/slider.js');
require('./js/tabs.js');
// require('./js/tabs2.js');



require('./js/scripts.js');

